import React, { useState, useEffect } from "react";
import {
  Md2ClockTimeOneOutline,
  Md2ClockTimeTwoOutline,
  Md2ClockTimeThreeOutline,
  Md2ClockTimeFourOutline,
  Md2ClockTimeFiveOutline,
  Md2ClockTimeSixOutline,
  Md2ClockTimeSevenOutline,
  Md2ClockTimeEightOutline,
  Md2ClockTimeNineOutline,
  Md2ClockTimeTenOutline,
  Md2ClockTimeElevenOutline,
  Md2ClockTimeTwelveOutline,
} from "react-icons-ng/md2";

const Clock = () => {
  const [iconIndex, setIconIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIconIndex((prevIndex) => (prevIndex + 1) % timeIcons.length);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const timeIcons = [
    Md2ClockTimeOneOutline,
    Md2ClockTimeTwoOutline,
    Md2ClockTimeThreeOutline,
    Md2ClockTimeFourOutline,
    Md2ClockTimeFiveOutline,
    Md2ClockTimeSixOutline,
    Md2ClockTimeSevenOutline,
    Md2ClockTimeEightOutline,
    Md2ClockTimeNineOutline,
    Md2ClockTimeTenOutline,
    Md2ClockTimeElevenOutline,
    Md2ClockTimeTwelveOutline,
  ];

  const IconComponent = timeIcons[iconIndex];

  return (
    <span className=" text-yellow-500 h-fit">
      <IconComponent size="1.5rem" />
    </span>
  );
};

export default Clock;
